import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentfulService } from '../contentful.service';
import { Entry } from 'contentful';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.css']
})
export class CourseListComponent implements OnInit {

  courses: Entry<any>[] = [];
  faqs: Entry<any>[] = [];
  menuOpen: boolean = false;
  siteUrl: any = environment.siteUrl;

  constructor(private router: Router, private contentfulService: ContentfulService) { }

  ngOnInit() {
    this.contentfulService.getCourses()
      .then(courses => this.courses = courses);

      this.contentfulService.getFaqs()
      .then(faqs => this.faqs = faqs);

      
      
  }

  goToCourseDetailsPage(courseId) {
    this.router.navigate(['/news', courseId]);
  }

  toggleMenu(){
    this.menuOpen = !this.menuOpen;
  }

}


// WEBPACK FOOTER //
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/app/course-list/course-list.component.ts